import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import produce from 'immer';
import { getCounselorInquiry } from 'app/api';

const CLEAR_COUNSELOR_LIST = 'loan.counselor/CLEAR_COUNSELOR_LIST';
export const clearCounselorAction = createAction(CLEAR_COUNSELOR_LIST);

const GET_COUNSELOR_INQUIRY = 'loan.counselor/GET_COUNSELOR_INQUIRY';
export const getCounselorInquiryAction = createAction(GET_COUNSELOR_INQUIRY, getCounselorInquiry);

const initialState = {
	counselorList: null,
};

export default handleActions(
	{
		[CLEAR_COUNSELOR_LIST]: (state) =>
			produce(state, (draft) => {
				draft.counselorList = null;
				return draft;
			}),
		...pender({
			type: GET_COUNSELOR_INQUIRY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.counselorList = data.staffs;
					return draft;
				}),
		}),
	},
	initialState,
);
